module.exports = "/images/london-26.jpg";